export enum VendorRoutePath {
	ROOT = '/vendor',
	LOGIN = '/vendor/login',
	DASHBOARD = '/vendor/dashboard',
	REDIRECT = '/vendor/redirect',
	NOT_AUTHORIZED = '/vendor/not-authorized',
}

export enum VendorRouteId {
	VENDOR_LOGIN_PAGE = 'VENDOR_LOGIN_PAGE',
	VENDOR_DASHBOARD_PAGE = 'VENDOR_DASHBOARD_PAGE',
	VENDOR_REDIRECT_PAGE = 'VENDOR_REDIRECT_PAGE',
}
